import DebitOrderMandate from './DebitOrderMandate'

export default DebitOrderMandate
